import reducer from 'state/mrDistribution/repeated-from/reducer';
import actions from 'state/mrDistribution/repeated-from/actionCreators';
import selectors from 'state/mrDistribution/repeated-from/selectors';

export { actions, selectors };
export default reducer;
